import { create } from 'zustand'

import * as dashboardApi from '../api/dashboard.api'

export const useAdminDashboardStore = create((set, get) => ({
  campaignLeads: null,
  conversionNumbers: null,
  ordersClosed: null,
  ordersLost: null,
  leadsManagement: null,
  ordersClosedBySalesperson: [],
  leadsNotFollowedUp: [],
  target: 0,
  achievement: 0,

  isLoading: true,
  hasLoaded: false,
  error: null,

  clearError: () => set({ error: null }),

  fetchDashboard: async (period = 'all', customRange = {}) => {
    const { hasLoaded } = get()

    // Only block the UI with shimmer on the first load — avoid jump on revisit
    set({
      isLoading: !hasLoaded,
      error: null,
    })

    try {
      const params = { period }
      if (period === 'custom' && customRange?.startDate)
        params.startDate = customRange.startDate
      if (period === 'custom' && customRange?.endDate)
        params.endDate = customRange.endDate

      const response = await dashboardApi.getAdminDashboard(params)
      const payload = response?.data ?? {}

      set({
        campaignLeads: payload?.campaignLeads || null,
        conversionNumbers: payload?.conversionNumbers || null,
        ordersClosed: payload?.ordersClosed || null,
        ordersLost: payload?.ordersLost || null,
        leadsManagement: payload?.leadsManagement || null,
        ordersClosedBySalesperson: payload?.ordersClosedBySalesperson || [],
        leadsNotFollowedUp: payload?.leadsNotFollowedUp || [],
        target: payload?.target ?? payload?.ordersClosed?.target ?? 0,
        achievement:
          payload?.achievement ?? payload?.ordersClosed?.achievement ?? 0,
        isLoading: false,
        hasLoaded: true,
        error: null,
      })
      return response
    } catch (error) {
      const message = error?.message || 'Failed to load dashboard metrics'

      set({
        isLoading: false,
        error: message,
      })
    }
  },

  removeLeadFromNotFollowedUp: (leadId) => {
    set((state) => ({
      leadsNotFollowedUp: state.leadsNotFollowedUp.filter(
        (lead) => String(lead._id) !== String(leadId),
      ),
    }))
  },

  updateLeadInNotFollowedUp: (leadId, patch) => {
    set((state) => ({
      leadsNotFollowedUp: state.leadsNotFollowedUp.map((lead) =>
        String(lead._id) === String(leadId) ? { ...lead, ...patch } : lead,
      ),
    }))
  },
}))
